import React from 'react';
import { Link } from 'react-router-dom';
import './Page.less';
import './Program.less';
import '../components/Table.less';
import BackBtn from '../components/UI/BackBtn';

const models = [
  {
    title: 'Большие вызовы СНТР',
    priorities: [
      { title: '15Б', description: 'Сырьевая зависимость и цифровая революция' },
      { title: '15В', description: 'Старение населения и здоровье нации' },
      { title: '15Е', description: 'Выработка и сохранение энергии' },
      { title: '15Ж', description: 'Угрозы национальной безопасности' },
    ]
  },
  {
    title: 'Ключевые приоритеты СНТР Университета',
    priorities: [
      { title: '21A', description: 'Передовые технологии и материалы' },
      { title: '21В', description: 'Превентивная и персонализированная медицина, обеспечение здорового долголетия' },
      { title: '21Б', description: 'Высокоэффективная и ресурсосберегающая энергетика, новые источники энергии' },
      { title: '21Д', description: 'Противодействие угрозам национальной и индивидуальной безопасности' },
    ]
  }
];

export default function Program() {

  return (
    <section className="page program-page">
      <div className="container">
        <BackBtn />
        <h2>О программе</h2>
        <section>
          <div style={{ display: 'flex', flexDirection: "column" }}>
            <p>
              <span className="heading">Миссия УрФУ</span>
              {' '}
              — повышение конкурентоспособности и обеспечение реиндустриализации, наращивание человеческого и научно-технического потенциала, сбалансированное обновление традиционных и развитие постиндустриальных отраслей экономики России.
            </p>
            <p>
              <span className="heading">Стратегический приоритет в реализации миссии на период до 2030 года</span>
              {' '}
              — локализация цепочек создания и внедрения критических и сквозных технологий.
            </p>
            <p>
              <span className="heading">Ключевая особенность УрФУ</span>
              {' '}
              — сильная кооперация с ведущими предприятиями Уральского региона, многие из которых являются международными корпорациями и занимают лидирующие позиции в мире в таких отраслях, как металлургия, машиностроение, энергетика, информационные технологии и др. Выраженные отличия УрФУ среди российских вузов – большой объем прикладных разработок с высоким уровнем технологической готовности и комплексных проектов по созданию высокотехнологичных производств (до 50% объема поступлений университета от НИОКТР), высокий уровень интеграции с академическими институтами Российской академии наук и мультидисциплинарная направленность научно-технологической, инновационной и образовательной деятельности.
              <br/>
              Являясь крупнейшим инженерным университетом России, УрФУ играет важную роль в развитии региональной научно-образовательной и инновационной экосистем, обеспечивая подготовку более 50 % инженерно-технических и научных кадров для предприятий региона.
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: "column" }}>
            <p>
              <span className="heading">Стратегическая цель развития университета</span>
              {' '}
              — формирование на территории Уральского федерального округа российского научно-образовательного и инновационного центра международного уровня для достижения технологического лидерства в рамках следующих национальных проектов: 
              <ul className="purpose-project-list">
                <li>Новые атомные и энергетические технологии</li>
                <li>Средства производства и автоматизации</li>
                <li>Новые материалы и химия</li>
                <li>Промышленное обеспечение транспортной мобильности</li>
                <li>Новые технологии сбережения здоровья</li>
                <li>Экономика данных и цифровая трансформация государства</li>
              </ul>
            </p>
            <p>
              <span className="heading">Основной механизм реализации цели</span>
              {' '}
              — кооперация университета с мировыми научно-образовательными центрами, институтами Уральского отделения Российской академии наук (УрО РАН), ведущими региональными и международными корпорациями, реализуемая при поддержке федеральных и региональных органов власти.
              <br/>
              Результативным механизмом устойчивой межрегиональной кооперации университетов, исследовательских организаций и индустриальных предприятий является созданный губернаторами Свердловской, Челябинской и Курганской областей при поддержке полномочного представителя Президента Российский Федерации в Уральском федеральном округе на базе УрФУ Уральский межрегиональный научно-образовательный центр мирового уровня (УМНОЦ) «Передовые производственные технологии и материалы.
            </p>
          </div>
        </section>
      </div>
      <div className="container">
        <h3>
          <Link to="/model">Целевая модель</Link>
        </h3>
      </div>
      {models.map((model) => (<div className="container colored-bg">
        <h3>{model.title}</h3>
        <section>
          {model.priorities.map((item, i) => (
            <div key={i}>
              {item.icon && <img src={item.icon} alt={item.icon} />}
              <div className="title">{item.title}</div>
              <p className="description">{item.description}</p>
            </div>
          ))}
        </section>
      </div>))}
      <div className='container'>
        <h3><Link to="/about/strategy">Стратегия УрФУ в области технологического лидерства</Link></h3>
        <h3><Link to="/about/pindicators">Целевые показатели эффективности реализации Программы развития УрФУ</Link></h3>
      </div>
    </section>
  );
}
